<template>
	<teleport
		v-if="setup.pageMounted && !inModal"
		:to="setup.ui.onLayoutNoAside ? '#page-subactions' : '#left-aside'">
		<shared-paged-list-actions
			:list-service="setup"
			:use="inModal ? undefined : ['search', 'filter']"/>
		<component
			:is="setup.filterService.filterComponent"
			v-if="!setup.ui.onLayoutNoAside"/>
	</teleport>

	<o-page
		:title="setup.listTitle"
		sticky-subactions
		class="temp-worker-list orion-page--full-width">
		<o-list
			v-bind="setup.listProps"
			v-model:page="setup.listPage">
			<template #default="{ item }">
				<temp-worker-card
					:temp-worker="item"
					:selected="setup.listItemIsSelected(item)"
					@select="setup.selectListItem(item)"/>
			</template>

			<template #footer-selected-actions>
				<template v-if="inModal">
					<o-button
						v-if="setup.canAddCandidate"
						color="info"
						outline
						@click="setup.addCandidate(setup.listProps.selected)">
						Ajouter {{ `le candidat`.pluralize(setup.listProps.selected.length, false) }}
					</o-button>
					<o-button
						v-if="setup.candidateService.inTalentPools() && setup.canRemoveCandidate"
						color="danger"
						outline
						@click="setup.removeCandidateFromGroupAsync(setup.listProps.selected)">
						Supprimer {{ `le candidat`.pluralize(setup.listProps.selected.length, false) }} du vivier
					</o-button>
				</template>

				<template v-else-if="setup.candidateService.inOrder()">
					<o-button
						v-if="setup.canRemoveCandidate"
						color="danger"
						outline
						@click="setup.removeCandidateFromOrderAsync()">
						Supprimer {{ `le candidat`.pluralize(setup.listProps.selected.length, false) }} de la commande
					</o-button>
				</template>
			</template>
		</o-list>

		<template
			v-if="!inModal"
			#[setup.slotName]>
			<o-toggle
				v-if="setup.candidateService.inOrder()"
				v-model="setup.filter.showRejected"
				reverse
				label="Afficher les candidats disqualifiés"
				@input="setup.refreshListAsync()"/>
			<o-icon
				v-if="setup.canAddCandidate"
				v-tooltip="`Ajouter un candidat`"
				font-icon="icon-interface-add-circle"
				@click="setup.openModalAddCandidate()"/>
			<div
				id="page-subactions"
				:ref="setup._pageSubactions"/>
		</template>

		<template
			v-else
			#actions>
			<o-icon
				class="order-modal-candidate__filter-trigger"
				font-icon="icon-interface-text-formatting-filter-1"
				@click="setup.openModalCandidateFilter()"/>
			<o-icon
				v-tooltip="`Tout sélectionner`"
				font-icon="icon-interface-validation-check"
				:class="{ 'text--success': allItemsOfThePageAreSelected }"
				@click="setup.toggleSelectAllListItems()"/>
		</template>
	</o-page>

	<div
		v-if="!setup.listProps.total"
		class="temp-worker-list--undefined">
		<o-icon font-icon="icon-interface-user-multiple"/>
		<p>Aucun candidat n'a été trouvé</p>
	</div>

	<teleport
		v-if="inModal && setup.isMounted"
		to="#orderModalFilter">
		<component :is="setup.filterService.listFilterComponent"/>
	</teleport>

	<o-aside
		v-if="!inModal"
		:options="{ size: 'lg' }">
		<router-view/>
	</o-aside>
</template>

<script setup lang="ts">
import { inject, provide } from 'vue';
import TempWorkerPagedListViewSetupService from '@/setup/temp-worker/TempWorkerPagedListViewSetupService';
import SharedPagedListActions from '@/components/shared/SharedPagedListActions.vue';
import TempWorkerCard from './TempWorkerCard.vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(TempWorkerPagedListViewSetupService.props);
const setup = new TempWorkerPagedListViewSetupService(props, _modal);
provide('OrderEntity', setup.props.order);
</script>

<style lang="less" scoped>
@import '@/styles/variables';
@import '@/styles/mixins';

.temp-worker-list{

	:deep(.orion-page__actions) {
		@media @layoutNavBottom {
			margin-top: 0.5rem;
		}
	}

	&--undefined {
    flex: 5;
		display: flex;
		flex-direction: column;
    align-items: center;
    gap: 2rem;
		margin-top: 6.25rem;

		.orion-icon {
			font-size: 6.25rem;
			color: var(--grey-light);
		}

		p {
			color: var(--grey);
			text-align: center;
			font-style: italic;
		}
	}
}

</style>
